module.exports = __webpack_public_path__ + "files/c044090bc9acd883ef449bb2d80b3b5f.svg";